module.exports = __webpack_public_path__ + "img/teachers_grid.3e0f2f43.png";